import { Toast } from "primereact/toast";
import React, { useRef, useState } from "react";
import Table from "./Table";
import Form from "./Form";
import { IPermissionProps } from "../../../../models/Login";
export interface IModel {
  open: boolean;
}
const DiceSetting = (permissions: IPermissionProps) => {
  const [modal, setModal] = useState({ open: false } as IModel);
  const [reload, setReload] = useState(false);
  const toast = useRef<any>(null);
  const hideDialog = () => {
    setModal({ open: false });
  };
  return (
    <>
      <Table permissions={permissions} reload={reload} setModal={setModal} toast={toast} />
      <Form open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload} />
      <Toast ref={toast} />
    </>
  );
};

export default DiceSetting;
